import {useRequest} from "ahooks";
import {userHome, getDepositInitInfo, getWithdrawInitInfo} from "@/services/user";

const useUserVariteies = () => {
  const userHomeReq = useRequest(async () => {
    const res = await userHome()
    return res
  }, { manual: false })
  return userHomeReq
}

const useDepositInit = () => {
  const getDepositInitInfoReq = useRequest(async (varietyCode, coin?) => {
    let data: any = {
      varietyCode
    }
    if (coin) {
      data = {...data, coin}
    }
    const res = await getDepositInitInfo(data)
    return res
  }, { manual: true })
  return getDepositInitInfoReq
}

const useWithdrawInit = () => {
  const getWithdrawInitInfoReq = useRequest(async (varietyCode, coin?) => {
    let data: any = {
      varietyCode
    }
    if (coin) {
      data = {...data, coin}
    }
    const res = await getWithdrawInitInfo(data)
    return res
  }, { manual: true })
  return getWithdrawInitInfoReq
}

export {
  useUserVariteies,
  useDepositInit,
  useWithdrawInit
}